// web/src/rendering/registry.ts
// The ONE binding point between backend `component` strings and React components.
// Backend emits {component: "line_chart", props: {...}}; frontend looks it up here.
// Adding a new visualization = one new file + one line here.
import { Grid } from "./components/layouts/Grid";
import { Row } from "./components/layouts/Row";
import { Column } from "./components/layouts/Column";
import { LineChart } from "./components/leaves/LineChart";
import { BarChart } from "./components/leaves/BarChart";
import { AreaChart } from "./components/leaves/AreaChart";
import { PieChart } from "./components/leaves/PieChart";
import { StatCard } from "./components/leaves/StatCard";
import { StatCards } from "./components/leaves/StatCards";
import { DataTable } from "./components/leaves/DataTable";
import { FinancialSummary } from "./components/leaves/FinancialSummary";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const registry = {
    // Layout primitives (recurse via children: RenderBlock[])
    grid: Grid,
    row: Row,
    column: Column,
    // Leaf primitives (render data)
    line_chart: LineChart,
    bar_chart: BarChart,
    area_chart: AreaChart,
    pie_chart: PieChart,
    stat_card: StatCard, // single KPI tile (used directly or via StatCards)
    stat_cards: StatCards, // array of KPI tiles — what chart__stat_cards() emits
    data_table: DataTable,
    financial_summary: FinancialSummary, // composite: KPI stats + sparkline + table
};
